import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ja from './locales/ja.json';
import br from './locales/br.json';
import cn from './locales/cn.json';
import de from './locales/de.json';
import es from './locales/es.json';
import hi from './locales/hi.json';
import kr from './locales/kr.json';
import tw from './locales/tw.json';
import ru from './locales/ru.json';
import vn from './locales/vn.json';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ja: { translation: ja },
      br: { translation: br },
      cn: { translation: cn },
      de: { translation: de },
      es: { translation: es },
      hi: { translation: hi },
      kr: { translation: kr },
      tw: { translation: tw },
      ru: { translation: ru },
      vn: { translation: vn },
    },
    fallbackLng: 'en', // 言語が検出されない場合のフォールバック
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
  });
// 中国: CN
// 韓国: KR
// 台湾: TW
// ドイツ: DE
// スペイン: ES
// ブラジル: BR
// インド: IN
//　ロシア：　RU
//　イギリス　BR
export default i18n;
